import React from "react";
import PageTitle from "../assets/images/city-image-navigation.jpeg";
export default function Kvkk() {
  return (
    <div className="container-fluid animate pageWrapper">
      <div className="container-fluid animate pageWrapper">
        {/* <!--pageTitle--> */}
        <div
          className="container-fluid section pageTitle"
          style={{
            backgroundImage: `url(${PageTitle})`,
          }}
        >
          <div className="container-fluid container">
            {/* <!--Text--> */}
            <div className="row middle-xs start-xm center-xs reverse">
              <div className="col-lg-4 col-md-3 col-sm-3 col-xm-2 col-xs-12 end-xm center-xs">
                <div className="slogan"></div>
              </div>
              <div className="col-lg-8 col-md-9 col-sm-9 col-xm-10 col-xs-12 title">
                <h1>KİŞİSEL VERİLERİN KORUNMASI KANUNU</h1>
                <span className="breadcrumbs">
                  <a href="/">Anasayfa</a> {">"}{" "}
                  <a href="#">KİŞİSEL VERİLERİN KORUNMASI KANUNU</a>
                </span>
              </div>
            </div>
            {/* <!--/Text--> */}
          </div>
        </div>
        {/* <!--/pageTitle--> */}

        {/* <!--page--> */}
        <div className="container-fluid section page-section">
          <div className="container-fluid container">
            {/* <!--kurumsal--> */}
            <div className="row">
              {/* <!--image--> */}
              <div className="col-xs">
                <span className="textCapsule">
                  <h3>
                    KİŞİSEL VERİLERİN KORUNMASI KANUNU (KVKK) AYDINLATMA METNİ
                  </h3>

                  <h4>1. Veri Sorumlusu</h4>
                  <p>
                    Karma Grup Dış Ticaret Otomotiv Makina İnşaat Nakliyat
                    Sanayi Limited Şirketi ("KARMA GRUP"), 6698 sayılı Kişisel
                    Verilerin Korunması Kanunu ("KVKK") kapsamında, Veri
                    Sorumlusu sıfatıyla, işleme amacına uygun, sınırlı ve ölçülü
                    şekilde talep ettiğimiz ve tarafınızca paylaşılan kişisel
                    verilerinizi işlemektedir. Bu doğrultuda, verileriniz,
                    işlenme amacına uygun olarak kaydedilecek, depolanacak,
                    muhafaza edilecek, yeniden düzenlenecek, hukuken bu verileri
                    talep etmeye yetkili kurumlarla paylaşılacak; KVKK ve diğer
                    ilgili mevzuatta öngörülen koşullar çerçevesinde yurt içi
                    veya yurt dışındaki üçüncü kişilere aktarılabilecek,
                    devredilebilecek, sınıflandırılabilecek ve KVKK’da
                    belirtilen diğer yöntemlerle işlenebilecektir. KVKK’nın 11.
                    maddesi kapsamındaki haklarınızı kullanmak amacıyla,
                    Beylikdüzü OSB Mah. 16. Cad. Shell Petrol İstasyonu No:3, İç
                    Kapı No:1 Beylikdüzü / İstanbul adresinde bulunan Karma Grup
                    Dış Ticaret Otomotiv Makina İnşaat Nakliyat Sanayi Limited
                    Şirketi'ne yazılı başvuruda bulunabilirsiniz. KARMA GRUP,
                    başvurunuzu niteliğine göre en kısa sürede ve en geç otuz
                    gün içinde ücretsiz olarak sonuçlandıracaktır. Ancak,
                    işlemin KARMA GRUP’a ek bir maliyet getirmesi halinde,
                    Kişisel Verileri Koruma Kurulu tarafından belirlenen
                    tarifedeki ücret alınabilecektir.
                  </p>

                  <h4>2. İşlenen Kişisel Veriler</h4>
                  <ul>
                    <li>
                      <p>
                        <strong>Kimlik Bilgileri:</strong> Ad, soyad, T.C.
                        kimlik numarası
                      </p>
                    </li>
                    <li>
                      <p>
                        <strong>İletişim Bilgileri:</strong> Telefon numarası,
                        e-posta adresi, adres
                      </p>
                    </li>
                    <li>
                      <p>
                        <strong>Araç Bilgileri:</strong> Plaka, marka-model,
                        şasi numarası
                      </p>
                    </li>
                    <li>
                      <p>
                        <strong>Hizmet Bilgileri:</strong> Montaj tarihi,
                        konumu, cihaz bilgileri
                      </p>
                    </li>
                    <li>
                      <p>
                        <strong>Finansal Bilgiler:</strong> Fatura, ödeme
                        yöntemi
                      </p>
                    </li>
                    <li>
                      <p>
                        <strong>Görsel/İşitsel Veriler:</strong> Kamera
                        kayıtları (varsa)
                      </p>
                    </li>
                    <li>
                      <p>
                        <strong>Şikayet/Talep Verileri</strong>
                      </p>
                    </li>
                    <li>
                      <p>
                        <strong>Çalışan veya Yetkili Bilgileri:</strong> Görev,
                        imza sirküleri, yetki belgesi
                      </p>
                    </li>
                  </ul>

                  <h4>3. Kişisel Verilerin İşlenme Amaçları</h4>
                  <ul>
                    <li>
                      <p>UTTS montaj ve teknik servis hizmetleri sunmak</p>
                    </li>
                    <li>
                      <p>Shell sistem entegrasyonu</p>
                    </li>
                    <li>
                      <p>Satış, fatura ve sözleşme süreçlerini yürütmek</p>
                    </li>
                    <li>
                      <p>Müşteri destek ve teknik yardım sağlamak</p>
                    </li>
                    <li>
                      <p>Kamu kurumlarına yasal bildirimlerde bulunmak</p>
                    </li>
                    <li>
                      <p>İç operasyonların planlanması</p>
                    </li>
                    <li>
                      <p>Hukuki yükümlülükleri yerine getirmek</p>
                    </li>
                  </ul>

                  <h4>4. Kişisel Verilerin Aktarılması</h4>
                  <p>
                    Kişisel verileriniz,{" "}
                    <strong>KVKK’nın 8. ve 9. maddeleri</strong> kapsamında;
                  </p>
                  <ul>
                    <li>
                      <p>
                        <strong>Shell & Turcas Petrol A.Ş.</strong> ve çözüm
                        ortaklarına
                      </p>
                    </li>
                    <li>
                      <p>UTTS altyapı sağlayıcılarına</p>
                    </li>
                    <li>
                      <p>Yasal zorunluluk halinde kamu kurumlarına</p>
                    </li>
                    <li>
                      <p>Hukuk, muhasebe ve denetim firmalarına</p>
                    </li>
                    <li>
                      <p>Bulut, e-posta, SMS sağlayıcılarına</p>
                    </li>
                  </ul>

                  <h4>5. Toplama Yöntemleri ve Hukuki Sebepler</h4>
                  <p>
                    Verileriniz; sözleşmeler, formlar, çağrılar, web sitesi,
                    mobil uygulama ve kamera sistemleri üzerinden;{" "}
                    <strong>
                      sözleşmenin kurulması ve ifası, meşru menfaat, hukuki
                      yükümlülük
                    </strong>{" "}
                    gibi KVKK madde 5/2’ye dayanılarak toplanmaktadır.
                  </p>

                  <h4>6. Haklarınız</h4>
                  <p>KVKK 11. madde kapsamında haklarınız:</p>
                  <ul>
                    <li>
                      <p>Verilerinizin işlenip işlenmediğini öğrenme</p>
                    </li>
                    <li>
                      <p>Bilgi talep etme</p>
                    </li>
                    <li>
                      <p>İşleme amacını öğrenme</p>
                    </li>
                    <li>
                      <p>Aktarıldığı 3. kişileri bilme</p>
                    </li>
                    <li>
                      <p>Düzeltme/silme isteme</p>
                    </li>
                    <li>
                      <p>Otomatik sistemler nedeniyle itiraz hakkı</p>
                    </li>
                    <li>
                      <p>Zarar doğması hâlinde tazminat talebi</p>
                    </li>
                  </ul>

                  <p>
                    Bu haklarınızı kullanmak için bizimle iletişime
                    geçebilirsiniz:
                  </p>
                  <ul>
                    <li>
                      <p>
                        <strong>E-posta:</strong>{" "}
                        <a href="mailto:info@kit-tak.com">info@kit-tak.com</a>
                      </p>
                    </li>
                    {/* <li>
                      <strong>Adres:</strong> [Kit-Tak Firma Adresi Buraya]
                    </li> */}
                    <li>
                      <p>
                        <strong>Telefon:</strong>{" "}
                        <a href="tel:+908502198559">0850 219 8559</a>
                      </p>
                    </li>
                  </ul>

                  <h4>7. Güncellemeler</h4>
                  <p>
                    Bu metin yasal değişikliklere göre güncellenebilir. Güncel
                    metne web sitemizden ulaşabilirsiniz.
                  </p>
                </span>
              </div>
              {/* <!--/image--> */}
            </div>
            {/* <!--/kurumsal--> */}
          </div>
        </div>
        {/* <!--/page--> */}
      </div>
    </div>
  );
}
